// extracted by mini-css-extract-plugin
module.exports = {"primary":"Typography_primary__SAN8l","secondary":"Typography_secondary__1gjET"};